import { PRESS_EVENTS } from '../shared.js'

export const img = {

    // Only radius is themed today (HaspObject.js's shared on('radius')
    // handler reads it for the outer rect). Declared here — not the full
    // MAIN_STYLE bundle — purely so the theme's flat radius value keeps
    // reaching the node via config.styles.main; img has no Property Editor
    // style panel and this isn't meant to add one.
    parts: {
        main: {
            label: 'Main',
            exportSuffix: '',
            order: 0,
            properties: {
                radius: { type: 'int', min: 0, max: 999, internal: true },
            },
        },
    },

    properties: {
        x: { type: 'int' }, y: { type: 'int' },
        width: { type: 'int', min: 0 }, height: { type: 'int', min: 0 },
        enabled:      { type: 'bool' },
        src:          { type: 'string' },
        filename:     { type: 'string', internal: true },
        // Primary reference to the shared ImageResource (see src/stores/imageStore.js) — a
        // uuid, not a filename. `src`/`filename` remain for backward compatibility with designs
        // saved before this field existed; HaspImage resolves via `image` when present, falling
        // back to `src`/`filename` and backfilling this field once resolved (see HaspImage.js).
        image:        { type: 'resource', resourceType: 'image', label: 'Image', internal: true },
        // min is 0, not negative: lv_img_get_angle() returns the raw internal uint16_t, so a
        // negative angle set here doesn't round-trip correctly on readback (e.g. -450 reads
        // back as 65086, not its 0-3599 equivalent). Clamping the allowed range to 0..3600
        // closes the bug at the entry point without needing normalization logic elsewhere.
        angle:        { type: 'int', min: 0, max: 3600, unit: '0.1°', hasp: true },
        auto_size:    { type: 'bool' },
        offset_x:     { type: 'int', label: 'offset x' },
        offset_y:     { type: 'int', label: 'offset y' },
        zoom:         { type: 'int', min: 0, max: 2048, label: 'zoom (256=1×)' },
        pivot_x:      { type: 'int', label: 'pivot x' },
        pivot_y:      { type: 'int', label: 'pivot y' },
        antialias:    { type: 'bool' },
        stretch_mode: {
            type: 'string', internal: true, default: 'none',
            options: ['none', 'keep_ratio', 'v_stretch', 'h_stretch', 'full'],
        },
        swipe:        { type: 'bool' },
        action:       { type: 'string', internal: true },
        groupid:      { type: 'int', min: 0, max: 15, exportSpecial: true },
        entityid:     { type: 'string', internal: true },
    },

    defaults: {
        properties: {
            x: 0, y: 0, width: 100, height: 100, angle: 0,
            enabled: true,
            src: '../media/hasp/haspImage.png', filename: '',
            // Without these, the generic export loop's "is this different from default" check
            // is unconditionally false, so antialias/offset_x/offset_y are silently never
            // exported no matter what the user sets (ATTR_ANTIALIAS/ATTR_OFFSET_X/
            // ATTR_OFFSET_Y, hasp_attribute.cpp). Adding the defaults alone fixes this.
            antialias: true, offset_x: 0, offset_y: 0,
            // No `image` default, matching dataset/font's convention (see label.js) —
            // HaspImage.objectExport() always explicitly (re-)writes `image` when set,
            // so this has no effect on export; omitting it just avoids the generic
            // export loop redundantly re-deriving the same value a second way.
        },
    },

    editorCapabilities:  ['can_transform', 'can_copy', 'has_objectmenu', 'keep_ratio', 'has_rotation'],
    runtimeCapabilities: ['has_action', 'has_group'],

    events: PRESS_EVENTS,
    bindings: {
        properties: { src: {}, angle: {} },
        actions: { hass_services: ['', 'homeassistant', 'openhasp', 'automation', 'climate', 'light', 'switch', 'scene', 'esphome'] },
        events: {},
    },
}
